import {useState} from 'react';
import {Button,Input,Modal,ModalContent,ModalHeader,ModalBody,ModalFooter} from '@nextui-org/react';
import {apiFetch} from '../lib/api';
import es from '../../../renderer/i18n/locales/es.json';

// Buscar una ID de Roblox por su número y liberarla. Para cuando la cuenta que la tenía ya no
// existe (borrada antes de que la baja soltara su ID) y la ficha del usuario no sirve: el
// usuario veía «Esta ID de Roblox ya está vinculada a otra cuenta» (ClickUp 12472jzedvv).
export default function RobloxIdLookup({isOpen,onClose}) {
  const [robloxId,setRobloxId]=useState('');
  const [result,setResult]=useState(null);
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  const [confirm,setConfirm]=useState(false);
  const [released,setReleased]=useState('');
  const reset=()=>{setResult(null);setError('');setConfirm(false);setReleased('');};
  const endpoint=id=>'/api/backoffice/roblox/'+encodeURIComponent(id);
  async function search(){
    if(!robloxId)return;
    reset();setBusy(true);
    try{setResult(await apiFetch(endpoint(robloxId)));}
    catch(e){setError(e.message);}
    finally{setBusy(false);}
  }
  async function release(){
    setBusy(true);setError('');
    try{await apiFetch(endpoint(result.robloxId),{method:'DELETE',body:{owner:result.owner}});setReleased(result.robloxId);setResult({...result,owner:'',ownerExists:false,ownerEmail:''});setConfirm(false);}
    catch(e){setError(e.message);}
    finally{setBusy(false);}
  }
  function close(){if(busy)return;setRobloxId('');reset();onClose();}
  return <Modal isOpen={isOpen} onOpenChange={open=>{if(!open)close();}} isDismissable={!busy} isKeyboardDismissDisabled={busy}>
    <ModalContent>
      <ModalHeader>{es.rb_id} · Roblox</ModalHeader>
      <ModalBody>
        <form className="flex items-end gap-2" onSubmit={event=>{event.preventDefault();search();}}>
          <Input size="sm" label={es.rb_id} inputMode="numeric" value={robloxId} isDisabled={busy} onValueChange={value=>{setRobloxId(value.replace(/\D/g,'').slice(0,16));reset();}} />
          <Button type="submit" isDisabled={!robloxId||busy} isLoading={busy&&!result}>Buscar</Button>
        </form>
        {result&&!result.owner&&<p className="text-success">{released?'Liberada. Ya se puede vincular con otra cuenta.':'Libre: no está vinculada a ninguna cuenta.'}</p>}
        {result&&result.owner&&<div className="flex flex-col gap-1">
          {result.ownerExists
            ?<p>Vinculada a <strong>{result.ownerEmail||'(sin correo)'}</strong></p>
            :<p className="text-warning">Vinculada a una cuenta que ya no existe.</p>}
          <p className="text-xs text-default-500">uid: {result.owner}{result.connected?' · conectada ahora':''}</p>
          {result.ownerExists&&<p className="text-xs text-default-500">La cuenta existe: si es un error de ID, también se puede desvincular desde su ficha.</p>}
          {confirm
            ?<div className="mt-2 flex items-center gap-2"><span>¿Liberar la ID {result.robloxId}?</span><Button size="sm" isDisabled={busy} onPress={()=>setConfirm(false)}>{es.common_cancel}</Button><Button size="sm" color="danger" isLoading={busy} onPress={release}>Liberar</Button></div>
            :<Button className="mt-2 self-start" size="sm" color="danger" variant="flat" isDisabled={busy} onPress={()=>setConfirm(true)}>Liberar la ID</Button>}
        </div>}
        {error&&<p role="alert" className="text-danger">{error}</p>}
      </ModalBody>
      <ModalFooter><Button isDisabled={busy} onPress={close}>Cerrar</Button></ModalFooter>
    </ModalContent>
  </Modal>;
}
